import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // "Instant" makes it jump to top immediately
    // "Smooth" scrolls it up (optional, but instant is better for page loads)
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' 
    });
  }, [pathname]); // Runs every time 'pathname' changes

  return null; // This component doesn't render anything visible
};

export default ScrollToTop;